import { Link } from "react-router-dom";
import { Seo } from "@/components/common/Seo";
import { MaskedLines } from "@/components/common/Kinetic";
import { CtaLink } from "@/components/common/Buttons";

export default function NotFound() {
  return (
    <section className="grain relative flex min-h-[80vh] items-center overflow-hidden bg-[#030712] pb-20 pt-36 text-white" data-testid="not-found-page">
      <Seo path="/404" noindex title="Page not found | Quantivo" description="The page you are looking for does not exist or has moved." />
      <div className="grid-dark pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
      <div className="container-q relative">
        <p className="font-mono text-[13px] text-cyan-300">error 404 · route not found</p>
        <MaskedLines lines={["This page doesn't", "exist."]} className="mt-6 text-5xl font-extrabold leading-[1.02] tracking-[-0.04em] sm:text-7xl" />
        <p className="mt-6 max-w-md text-base text-slate-300">The link may be broken or the page may have moved. Try one of these instead.</p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <CtaLink to="/" data-testid="not-found-home">Back to Home</CtaLink>
          <CtaLink to="/contact" variant="ghostDark" arrow="right" data-testid="not-found-contact">Contact us</CtaLink>
        </div>
        <p className="mt-10 text-sm text-slate-400">Or browse <Link to="/services" className="text-white underline underline-offset-4">our services</Link>.</p>
      </div>
    </section>
  );
}
